module.exports = __webpack_public_path__ + "fonts/Calibre-Light.183de736.woff2";